import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { RenderTextArea } from '../../../component/formInput';

class TaduNoteModal extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
      }

  }
  componentDidMount() {

  }
  
  submit = (values) => {
    const { onHide, invoice_code } = this.props;
    return axios({
      method: 'post',
      url: window.api_url+ '/admin/api/invoice/set_tadu_note',
      data: {
        invoice_code: invoice_code,
        tadu_note: values.tadu_note
      },
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        onHide();
      }else {
        throw new SubmissionError(response.data.error);
      }
    })
  }
  
  render() {
    const { title, handleSubmit, submitting, onHide, userProfile } = this.props;
    const modalConfig = { backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };

    const newModal = <div style={{ width: '30%' }}>
    <Modal
      {...modalConfig}
      aria-labelledby="contained-modal-title-lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-sm"><center>{title}</center> </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="form-horizontal" role="form" onSubmit={handleSubmit(this.submit)}>
          <Field name="tadu_note" label="" placeholder="Vui lòng nhập ghi chú..." component={RenderTextArea}></Field>
          <div className="text-right">
            <a onClick={()=>onHide()} className={"btn"}>
              Đóng
            </a>
            <button type="submit" className={"btn bg-blue btn-primary " + (submitting ? "disabled" : "")}>
              Lưu <i className="icon-arrow-right14 position-right"></i>
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
    </div>
    return newModal;
  }
};
const mapState = (state, props) => ({
  initialValues: {
    tadu_note: props.invoiceObject && props.invoiceObject.tadu_note
  },
  userProfile: state.userProfile.data
});

const mapDispatch = dispatch => ({
  
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'TaduNoteModal',
    destroyOnUnmount: true,
    enableReinitialize: true
  })(withRouter(TaduNoteModal))));
